import { Radio, type RadioGroupProps } from 'antd';

interface BooleanInputProps extends RadioGroupProps {}

export default function BooleanInput({
  onChange,
  value,
  ...props
}: BooleanInputProps) {
  return (
    <Radio.Group onChange={onChange} value={value} {...props}>
      <Radio.Button value="true">True</Radio.Button>
      <Radio.Button value="false">False</Radio.Button>
    </Radio.Group>
  );
}
